import(/* webpackMode: "eager" */ "/var/www/rallly/apps/web/src/app/global-error.tsx");
